// Defoalt is for HRM API
export const environment = {
  baseUrl: 'https://api.ebill.so:3222/api',
  url: 'https://api.ebill.so:3222/',
  production: true
};